export const RingDiameterConversionValues: Array<{
    DIAMETER: number
    CUSTOM_WIDTH: number
    USA_CANADA: string
    ENGLAND: string | '--'
    SWITZERLAND: number | string
}> = [
    // {
    //     DIAMETER: 13.27,
    //     CUSTOM_WIDTH: 42,
    //     USA_CANADA: '2',
    //     ENGLAND: 'D',
    //     SWITZERLAND: 1.75,
    // },
    // {
    //     DIAMETER: 13.46,
    //     CUSTOM_WIDTH: 42,
    //     USA_CANADA: '2 1/4',
    //     ENGLAND: 'D 1/2',
    //     SWITZERLAND: 2.25,
    // },
    // {
    //     DIAMETER: 13.66,
    //     CUSTOM_WIDTH: 43,
    //     USA_CANADA: '2 1/2',
    //     ENGLAND: 'E',
    //     SWITZERLAND: 3,
    // },
    // {
    //     DIAMETER: 13.88,
    //     CUSTOM_WIDTH: 44,
    //     USA_CANADA: '2 3/4',
    //     ENGLAND: 'E 1/2',
    //     SWITZERLAND: 3.5,
    // },
    // {
    //     DIAMETER: 14.07,
    //     CUSTOM_WIDTH: 44,
    //     USA_CANADA: '3',
    //     ENGLAND: 'F',
    //     SWITZERLAND: 4.25,
    // },
    // {
    //     DIAMETER: 14.26,
    //     CUSTOM_WIDTH: 45,
    //     USA_CANADA: '3 1/4',
    //     ENGLAND: 'F 1/2',
    //     SWITZERLAND: 4.75,
    // },
    // {
    //     DIAMETER: 14.48,
    //     CUSTOM_WIDTH: 46,
    //     USA_CANADA: '3 1/2',
    //     ENGLAND: 'G',
    //     SWITZERLAND: 5.5,
    // },
    {
        DIAMETER: 14.67, // todo 14.64 should be value here based on math calculation
        CUSTOM_WIDTH: 46,
        USA_CANADA: '3 3/4',
        ENGLAND: 'G 1/2',
        SWITZERLAND: 6,
    },
    {
        DIAMETER: 14.9,
        CUSTOM_WIDTH: 47,
        USA_CANADA: '4',
        ENGLAND: 'H',
        SWITZERLAND: 6.75,
    },
    {
        DIAMETER: 15.09,
        CUSTOM_WIDTH: 47,
        USA_CANADA: '4 1/4',
        ENGLAND: 'H 1/2',
        SWITZERLAND: 7.5,
    },
    {
        DIAMETER: 15.28,
        CUSTOM_WIDTH: 48,
        USA_CANADA: '4 1/2',
        ENGLAND: 'I',
        SWITZERLAND: 8,
    },
    {
        DIAMETER: 15.5,
        CUSTOM_WIDTH: 49,
        USA_CANADA: '4 3/4',
        ENGLAND: 'J',
        SWITZERLAND: 8.75,
    },
    {
        DIAMETER: 15.69,
        CUSTOM_WIDTH: 49,
        USA_CANADA: '5',
        ENGLAND: 'J 1/2',
        SWITZERLAND: 9.25,
    },
    {
        DIAMETER: 15.92,
        CUSTOM_WIDTH: 50,
        USA_CANADA: '5 1/4',
        ENGLAND: 'K',
        SWITZERLAND: 10,
    },
    {
        DIAMETER: 16.11,
        CUSTOM_WIDTH: 51,
        USA_CANADA: '5 1/2',
        ENGLAND: 'K 1/2',
        SWITZERLAND: 10.5,
    },
    {
        DIAMETER: 16.3,
        CUSTOM_WIDTH: 51,
        USA_CANADA: '5 3/4',
        ENGLAND: 'L',
        SWITZERLAND: 11.25,
    },
    {
        DIAMETER: 16.52,
        CUSTOM_WIDTH: 52,
        USA_CANADA: '6',
        ENGLAND: 'L 1/2',
        SWITZERLAND: 11.75,
    },
    {
        DIAMETER: 16.71,
        CUSTOM_WIDTH: 53,
        USA_CANADA: '6 1/4',
        ENGLAND: 'M',
        SWITZERLAND: 12.5,
    },
    {
        DIAMETER: 16.9,
        CUSTOM_WIDTH: 53,
        USA_CANADA: '6 1/2',
        ENGLAND: 'M 1/2',
        SWITZERLAND: 13.25,
    },
    {
        DIAMETER: 17.13,
        CUSTOM_WIDTH: 54,
        USA_CANADA: '6 3/4',
        ENGLAND: 'N',
        SWITZERLAND: 13.75,
    },
    {
        DIAMETER: 17.32,
        CUSTOM_WIDTH: 54,
        USA_CANADA: '7',
        ENGLAND: 'N 1/2',
        SWITZERLAND: 14.5,
    },
    {
        DIAMETER: 17.54,
        CUSTOM_WIDTH: 55,
        USA_CANADA: '7 1/4',
        ENGLAND: 'O',
        SWITZERLAND: 15,
    },
    {
        DIAMETER: 17.73,
        CUSTOM_WIDTH: 56,
        USA_CANADA: '7 1/2',
        ENGLAND: 'O 1/2',
        SWITZERLAND: 15.75,
    },
    {
        DIAMETER: 17.92,
        CUSTOM_WIDTH: 56,
        USA_CANADA: '7 3/4',
        ENGLAND: 'P',
        SWITZERLAND: 16.25,
    },
    {
        DIAMETER: 18.14,
        CUSTOM_WIDTH: 57,
        USA_CANADA: '8',
        ENGLAND: 'P 1/2',
        SWITZERLAND: 17,
    },
    {
        DIAMETER: 18.33,
        CUSTOM_WIDTH: 58,
        USA_CANADA: '8 1/4',
        ENGLAND: 'Q',
        SWITZERLAND: 17.5,
    },
    {
        DIAMETER: 18.56,
        CUSTOM_WIDTH: 58,
        USA_CANADA: '8 1/2',
        ENGLAND: 'Q 1/2',
        SWITZERLAND: 18.25,
    },
    {
        DIAMETER: 18.75,
        CUSTOM_WIDTH: 59,
        USA_CANADA: '8 3/4',
        ENGLAND: 'R',
        SWITZERLAND: 19,
    },
    {
        DIAMETER: 18.94,
        CUSTOM_WIDTH: 60,
        USA_CANADA: '9',
        ENGLAND: 'R 1/2',
        SWITZERLAND: 19.5,
    },
    {
        DIAMETER: 19.16,
        CUSTOM_WIDTH: 60,
        USA_CANADA: '9 1/4',
        ENGLAND: 'S',
        SWITZERLAND: 20.25,
    },
    {
        DIAMETER: 19.35,
        CUSTOM_WIDTH: 61,
        USA_CANADA: '9 1/2',
        ENGLAND: 'S 1/2',
        SWITZERLAND: 20.75,
    },
    {
        DIAMETER: 19.54,
        CUSTOM_WIDTH: 61,
        USA_CANADA: '9 3/4',
        ENGLAND: 'T',
        SWITZERLAND: 21.5,
    },
    {
        DIAMETER: 19.77,
        CUSTOM_WIDTH: 62,
        USA_CANADA: '10',
        ENGLAND: 'T 1/2',
        SWITZERLAND: 22,
    },
    {
        DIAMETER: 19.96,
        CUSTOM_WIDTH: 63,
        USA_CANADA: '10 1/4',
        ENGLAND: 'U',
        SWITZERLAND: 22.75,
    },
    {
        DIAMETER: 20.18,
        CUSTOM_WIDTH: 63,
        USA_CANADA: '10 1/2',
        ENGLAND: 'U 1/2',
        SWITZERLAND: 23.25,
    },
    {
        DIAMETER: 20.37,
        CUSTOM_WIDTH: 64,
        USA_CANADA: '10 3/4',
        ENGLAND: 'V',
        SWITZERLAND: 24,
    },
    {
        DIAMETER: 20.56,
        CUSTOM_WIDTH: 65,
        USA_CANADA: '11',
        ENGLAND: 'V 1/2',
        SWITZERLAND: 24.75,
    },
    {
        DIAMETER: 20.79,
        CUSTOM_WIDTH: 65,
        USA_CANADA: '11 1/4',
        ENGLAND: 'W',
        SWITZERLAND: 25.25,
    },
    {
        DIAMETER: 20.98,
        CUSTOM_WIDTH: 66,
        USA_CANADA: '11 1/2',
        ENGLAND: 'W 1/2',
        SWITZERLAND: 26,
    },
    {
        DIAMETER: 21.2,
        CUSTOM_WIDTH: 67,
        USA_CANADA: '11 3/4',
        ENGLAND: 'X',
        SWITZERLAND: 26.5,
    },
    {
        DIAMETER: 21.39,
        CUSTOM_WIDTH: 67,
        USA_CANADA: '12',
        ENGLAND: 'X 1/2',
        SWITZERLAND: 27.25,
    },
    {
        DIAMETER: 21.58,
        CUSTOM_WIDTH: 68,
        USA_CANADA: '12 1/4',
        ENGLAND: 'Y',
        SWITZERLAND: 27.75,
    },
    {
        DIAMETER: 21.8,
        CUSTOM_WIDTH: 69,
        USA_CANADA: '12 1/2',
        ENGLAND: 'Z',
        SWITZERLAND: 28.5,
    },
    {
        DIAMETER: 22,
        CUSTOM_WIDTH: 69,
        USA_CANADA: '12 3/4',
        ENGLAND: 'Z 1/2',
        SWITZERLAND: 29,
    },
    {
        DIAMETER: 22.19,
        CUSTOM_WIDTH: 70,
        USA_CANADA: '13',
        ENGLAND: '--',
        SWITZERLAND: 29.75,
    },
    {
        DIAMETER: 22.41,
        CUSTOM_WIDTH: 70,
        USA_CANADA: '13 1/4',
        ENGLAND: 'Z1',
        SWITZERLAND: 30.5,
    },
    {
        DIAMETER: 22.6,
        CUSTOM_WIDTH: 71,
        USA_CANADA: '13 1/2',
        ENGLAND: '--',
        SWITZERLAND: 31,
    },
    {
        DIAMETER: 22.82,
        CUSTOM_WIDTH: 72,
        USA_CANADA: '13 3/4',
        ENGLAND: 'Z2',
        SWITZERLAND: 31.75,
    },
    {
        DIAMETER: 23.01,
        CUSTOM_WIDTH: 72,
        USA_CANADA: '14',
        ENGLAND: 'Z3',
        SWITZERLAND: 32.25,
    },
    {
        DIAMETER: 23.2,
        CUSTOM_WIDTH: 73,
        USA_CANADA: '14 1/4',
        ENGLAND: '--',
        SWITZERLAND: 33,
    },
    {
        DIAMETER: 23.43,
        CUSTOM_WIDTH: 74,
        USA_CANADA: '14 1/2',
        ENGLAND: 'Z4',
        SWITZERLAND: 33.5,
    },
    {
        DIAMETER: 23.62,
        CUSTOM_WIDTH: 74,
        USA_CANADA: '14 3/4',
        ENGLAND: '--',
        SWITZERLAND: 34.25,
    },
]
